<template>
  <div class="content-box">
    <div class="login-top">
      <div class="inline logo">
      <img src="../assets/logo.png" alt=""/>
      </div>
      <div class="inline go-back" @click="$router.push({path: '/', query: {device: $route.query.device, hospital: $route.query.hospital}})">返回</div>
      <span class="inline fr">下单</span>
    </div>
    <div class="content-box-sco">
      <div class="title-pro tc">{{name}}</div>
      <div class="form-box">
        <div class="form-title">联系方式</div>
        <div class="formtip-txt">请告诉我们您的手机号码，使我们能及时通知您服务的进度</div>
        <el-form :model="form" label-position="left" label-width="80px" ref="patient" class="demo-form">
          <el-form-item label='手机号码' prop="patient_mobile" :rules="[{ required: true, message: '不能为空' }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号' }]">
            <el-input :disabled="$route.query.orderId ? true : false" maxlength="11" v-model="form.patient_mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label='姓名' prop="patient_name" :rules="[{ required: true, message: '不能为空' }, { pattern: /^([\u4e00-\u9fa5]{2,20}|[a-zA-Z\.\s]{2,20})$/, message: '请输入正确姓名'}]">
            <el-input v-model="form.patient_name" placeholder="请输入患者姓名" maxlength="200"></el-input>
          </el-form-item>
          <!-- <el-form-item label='验证码' prop="code" :rules="{ required: true, message: '不能为空' }">
            <el-input type="number" v-model="form.code" placeholder="请输入验证码" maxlength="6"></el-input>
          <el-button class="identifybox" :disabled="disabled" type="primary" @click="sendCode">{{s > 0 ? `(${s})s` : '发送验证码'}}</el-button>
          </el-form-item> -->
          <!-- <el-form-item v-if="!$route.query.orderId" label='验证码' prop="code">
            <el-input type="number" v-model="form.code" placeholder="请输入验证码" maxlength="6"></el-input>
          <el-button class="identifybox" :disabled="disabled" type="primary" @click="sendCode">{{s > 0 ? `(${s})s` : '发送验证码'}}</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="form-box">
        <div class="form-title">就诊信息</div>
        <!-- <div class="formtip-txt">患者姓名将作为发票开具抬头，请务必填写正确！</div> -->
        <el-form :model="form" label-position="left" label-width="80px" ref="depart" class="demo-form">
          <!-- <el-form-item class="invoice-item" label='患者姓名' prop="patient_name" :rules="[{ required: true, message: '不能为空' }, { pattern: /^([\u4e00-\u9fa5]{2,20}|[a-zA-Z\.\s]{2,20})$/, message: '请输入正确患者姓名'}]">
            <el-input v-model="form.patient_name" placeholder="请输入患者姓名"></el-input>
          </el-form-item> -->
          <el-form-item class="invoice-item" v-if="$route.query.orderId" label='就诊医院' prop="hospital_name">
            <el-input :disabled="$route.query.orderId ? true : false" v-model="form.hospital_name" placeholder="请输入就诊医院" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item class="invoice-item" label='就诊科室' prop="depart_name" :rules="[{ required: true, message: '不能为空' }]">
            <el-input :disabled="$route.query.orderId ? true : false" v-model="form.depart_name" placeholder="请输入就诊科室" maxlength="20"></el-input>
          </el-form-item>
          <!-- <el-form-item class="invoice-item" label='就诊医生' prop="doctor_name">
            <el-input v-model="form.doctor_name" placeholder="请输入就诊科室" maxlength="20"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="form-box">
        <div class="form-title">发票信息</div>
        <el-form :model="form" label-position="left" label-width="110px" ref="invoice" class="demo-form">
          <el-form-item class="radio-item" prop="invoice_type" :rules="[{ required: true, message: '不能为空' }]">
             <el-radio-group @change="change" v-model="form.invoice_type">
              <el-radio label="0">不开发票</el-radio>
              <el-radio label="1">电子发票(个人)</el-radio>
              <!-- <el-radio label="2">电子发票(企业)</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '1'" class="invoice-item" label='姓名' prop="invoice_title" :rules="[{ required: true, message: '不能为空' }, { pattern: /^([\u4e00-\u9fa5]{2,20}|[a-zA-Z\.\s]{2,20})$/, message: '请输入正确姓名'}]">
            <el-input maxlength="200" v-model="form.invoice_title" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='名称' prop="invoice_title" :rules="[{ required: true, message: '不能为空' }, { pattern: /^([\u4e00-\u9fa5]{2,20}|[a-zA-Z\.\s]{2,20})$/, message: '请输入正确名称'}]">
            <el-input maxlength="200" v-model="form.invoice_title" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='纳税人识别号' prop="invoice_ident" :rules="[{ required: true, message: '不能为空' }]">
            <el-input maxlength="200" v-model="form.invoice_ident" placeholder="请输入纳税人识别号"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='纳税人地址' prop="invoice_addr" :rules="[{ required: true, message: '不能为空' }]">
            <el-input maxlength="200" v-model="form.invoice_addr" placeholder="请输入纳税人地址"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='纳税人电话' prop="invoice_phone" :rules="[{ required: true, message: '不能为空' }, { pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '请输入正确电话'}]">
            <el-input maxlength="200" v-model="form.invoice_phone" placeholder="请输入纳税人电话"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='开户银行' prop="invoice_bank" :rules="[{ required: true, message: '不能为空' }]">
            <el-input maxlength="200" v-model="form.invoice_bank" placeholder="请输入开户银行"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='银行账户' prop="invoice_bank_account" :rules="[{ required: true, message: '不能为空' }]">
            <el-input maxlength="200" v-model="form.invoice_bank_account" placeholder="请输入银行账户"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type !== '0'" class="invoice-item" label='邮箱' prop="invoice_mail" :rules="[{ required: true, message: '不能为空' }, {pattern:  /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, message: '格式不正确'}]">
            <el-input maxlength="200" v-model="form.invoice_mail" placeholder="电子发票将发送至您邮箱"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='备注' prop="comment">
            <el-input type="textarea" maxlength="200" v-model="form.comment" placeholder="备注"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='收票人手机' prop="invoice_recv_phone" :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '格式不正确' }]">
            <el-input maxlength="200" v-model="form.invoice_recv_phone" placeholder="请输入收票人手机"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-button :loading="btnLoading" type="primary" @click="handleLogin" class='pay-btn'>我要购买此服务</el-button>
    </div>
  </div>
</template>

<script>
import { postService, getInfo, changeService, getService, sendsms } from '@/api'
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      form: {
        patient_mobile: '',
        patient_name: '',
        depart_name: '',
        // doctor_name: '',
        invoice_type: '0',
        invoice_addr: '',
        invoice_title: '',
        // code: '',
        hospital_name: '',
        invoice_mail: '',
        invoice_ident: '',
        invoice_phone: '',
        invoice_bank: '',
        invoice_bank_account: '',
        invoice_recv_phone: '',
        comment: ''
      },
      btnLoading: false,
      s: 0,
      timer: null,
      disabled: false,
      name: ''
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    change (val) {
      // if (val === '1') {
      //   this.form.invoice_addr = ''
      // } else if (val === '2') {
      //   this.form.invoice_mail = ''
      // } else {
      //   this.form.invoice_addr = ''
      //   this.form.invoice_mail = ''
      // }
    },
    ...mapMutations(['setOrder']),
    handleLogin () {
      let that = this
      let p1 = new Promise(function (resolve, reject) {
        that.$refs.patient.validate((valid) => {
          if (valid) {
            resolve()
          }
        })
      })
      let p2 = new Promise(function (resolve, reject) {
        that.$refs.depart.validate((valid) => {
          if (valid) {
            resolve()
          }
        })
      })
      let p3 = new Promise(function (resolve, reject) {
        that.$refs.invoice.validate((valid) => {
          if (valid) {
            resolve()
          }
        })
      })
      Promise.all([p2, p1, p3]).then(function () {
        that.submit()
      })
    },
    submit () {
      this.btnLoading = true
      var formData = new FormData()
      if (this.$route.query.orderId) {
        // formData.append('patient_mobile', this.form.patient_mobile)
        formData.append('patient_name', this.form.patient_name)
        // formData.append('depart_name', this.form.depart_name)
        // formData.append('doctor_name', this.form.doctor_name)
        formData.append('invoice_type', this.form.invoice_type)
        formData.append('invoice_addr', this.form.invoice_addr)
        formData.append('invoice_title', this.form.invoice_title)
        // formData.append('hospital_name', this.form.hospital_name)
        formData.append('invoice_mail', this.form.invoice_mail)
        formData.append('invoice_ident', this.form.invoice_ident)
        formData.append('invoice_phone', this.form.invoice_phone)
        formData.append('invoice_bank', this.form.invoice_bank)
        formData.append('invoice_bank_account', this.form.invoice_bank_account)
        formData.append('invoice_recv_phone', this.form.invoice_recv_phone)
        formData.append('comment', this.form.comment)
        formData.append('hospital_id', this.$route.query.hospital)
        // formData.append('code', this.form.code)
        formData.append('token', this.$cookies.get('h5_token'))
        changeService(this.$route.query.orderId, formData).then(res => {
          if (res.code === -1 && res.msg === '未登录') {
            this.$notify.error({
              message: res.msg,
              showClose: false,
              offset: 100,
              duration: 2000
            })
            this.$cookies.remove('h5_user')
            this.$cookies.remove('h5_token')
            this.$router.push({path: '/login', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
          } else {
            this.$router.push({path: '/pay', query: {device: this.$route.query.device, hospital: this.$route.query.hospital, orderId: res.data.order_id}})
          }
        }).finally(() => {
          this.btnLoading = false
        }).catch((err) => {
          if (err.code === -1 && err.msg === '未登录') {
            this.$cookies.remove('h5_user')
            this.$cookies.remove('h5_token')
            this.$router.push({path: '/login', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
          }
        })
      } else {
        formData.append('patient_mobile', this.form.patient_mobile)
        formData.append('patient_name', this.form.patient_name)
        formData.append('depart_name', this.form.depart_name)
        // formData.append('doctor_name', this.form.doctor_name)
        formData.append('invoice_type', this.form.invoice_type)
        formData.append('invoice_addr', this.form.invoice_addr)
        formData.append('invoice_title', this.form.invoice_title)
        formData.append('hospital_name', this.form.hospital_name)
        formData.append('invoice_mail', this.form.invoice_mail)
        formData.append('invoice_ident', this.form.invoice_ident)
        formData.append('invoice_phone', this.form.invoice_phone)
        formData.append('invoice_bank', this.form.invoice_bank)
        formData.append('invoice_bank_account', this.form.invoice_bank_account)
        formData.append('invoice_recv_phone', this.form.invoice_recv_phone)
        formData.append('comment', this.form.comment)
        formData.append('hospital_id', this.$route.query.hospital)
        formData.append('token', this.$cookies.get('h5_token'))
        // formData.append('code', this.form.code)
        postService(this.$route.query.device, formData).then(res => {
          if (res.code === -1 && res.msg === '未登录') {
            this.$cookies.remove('h5_user')
            this.$cookies.remove('h5_token')
            this.$router.push({path: '/login', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
          } else {
            this.$router.push({path: '/pay', query: {device: this.$route.query.device, hospital: this.$route.query.hospital, orderId: res.data.order_id}})
          }
        }).finally(() => {
          this.btnLoading = false
        }).catch((err) => {
          if (err.code === -1 && err.msg === '未登录') {
            this.$cookies.remove('h5_user')
            this.$cookies.remove('h5_token')
            this.$router.push({path: '/login', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
          }
        })
      }
    },
    sendCode () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      if (this.form.patient_mobile) {
        this.loading = true
        var formData = new FormData()
        formData.append('mobile', this.form.patient_mobile)
        formData.append('type', 'check_user')
        sendsms(formData).then(res => {
          this.$notify.success({
            message: res.msg,
            showClose: false,
            offset: 100,
            duration: 2000
          })
          this.s = 60
          this.disabled = true
          let _this = this
          this.timer = setInterval(() => {
            if (_this.s <= 0) {
              clearInterval(_this.timer)
              _this.disabled = false
            } else {
              _this.s--
            }
          }, 1000)
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify.error({
          message: '请输入手机号',
          showClose: false,
          offset: 100,
          duration: 2000
        })
      }
    }
  },
  mounted () {
    if (this.$route.query.orderId) {
      var formData = new FormData()
      formData.append('token', this.$cookies.get('h5_token'))
      getInfo(this.$route.query.orderId, formData).then(res => {
        this.form.patient_mobile = res.data.patient_mobile
        this.form.patient_name = res.data.patient_name
        this.form.depart_name = res.data.depart_name
        // this.form.doctor_name = res.data.doctor_name
        this.form.invoice_addr = res.data.invoice_addr
        this.form.invoice_title = res.data.invoice_title
        this.form.hospital_name = res.data.hospital_name
        this.form.invoice_type = res.data.invoice_type + ''
        this.form.invoice_mail = res.data.invoice_mail
        this.form.invoice_ident = res.data.invoice_ident
        this.form.invoice_phone = res.data.invoice_phone
        this.form.invoice_bank = res.data.invoice_bank
        this.form.invoice_bank_account = res.data.invoice_bank_account
        this.form.invoice_recv_phone = res.data.invoice_recv_phone
        this.form.comment = res.data.comment
      })
    }
    getService(this.$route.query.device ? this.$route.query.device : '').then(res => {
      this.name = res.data.name
    })
  }
}
</script>

<style lang="scss" scoped>
.title-pro{
  line-height: 60px;
  font-size: 16px;
  color: #539edf;
}
.form-title{
  font-size: 16px;
  color: #539edf;
  line-height: 30px;
}
.formtip-txt{
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/order.vue